import classNames from 'classnames';
import React from 'react';
import { type IVectorLayerProps } from '@meitu/saas-editor-core/es/version-types';
import { HeaderToolbar } from '@/components/header-toolbar';
import { useHeaderTool } from '@/hooks/use-common-tool';
import { useEditor } from '@/hooks/use-editor';
import { useListenActivePickLayerProps } from '@/hooks/use-listen-layer-props';
import { useLocaleStore } from '@/i18n';
import { type PanelTab } from '../../types';
import './style.less';

type Props = {
    layerId: string;
    currentTab: PanelTab;
    onSwitchTab: (tab: PanelTab) => void;
    recordId?: number;
};

export const VectorPanelHeader: React.FC<Props> = ({ layerId, currentTab, onSwitchTab, recordId }) => {
    const { $t } = useLocaleStore();
    const editor = useEditor();
    const headerToolCallback = useHeaderTool(editor, 9, recordId);

    const textInfo = useListenActivePickLayerProps(editor, (layer) => {
        if (!layer) return null;

        const layerData = layer.data as IVectorLayerProps;
        return layerData.textInfo;
    });

    const showTabHeader = !!textInfo;
    const handleSwitchTab = (tab: PanelTab) => {
        if (tab === currentTab) return;
        onSwitchTab(tab);
    };
    return (
        <div className="vector-panel-header">
            <HeaderToolbar id={layerId} editor={editor} style={{ padding: 16 }} {...headerToolCallback} />

            {showTabHeader && (
                <div className="vector-panel-header__tabs" data-active-tab={currentTab}>
                    {/* 图形 */}
                    <div
                        className={classNames('vector-panel-header__tab', {
                            'vector-panel-header__tab--active': currentTab === 'image',
                        })}
                        onClick={() => handleSwitchTab('image')}
                    >
                        <span>{$t((v) => v.panel.vectorPanel.vectorShape)}</span>
                    </div>

                    {/* 文字 */}
                    <div
                        className={classNames('vector-panel-header__tab', {
                            'vector-panel-header__tab--active': currentTab === 'text',
                        })}
                        onClick={() => handleSwitchTab('text')}
                    >
                        <span>{$t((v) => v.panel.textPanel.text)}</span>
                    </div>
                </div>
            )}
        </div>
    );
};
